(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($) {
  'use_strict';

  $(function () {
    if (typeof gtag == 'undefined') {
      console.warn('GA undefined, ensure google analytics is loaded. (You might also be logged in since GA isnt loaded for logged in users.)');
      return;
    }

    // $(document.body)
    //     .on('click', '.hpy_ga_ta_ev', function(e) {
    //         send_event( $(this) );
    //     })

    $('.hpy_ga_ta_ev').on('click', function () {
      send_event($(this));
    });
  });
  function send_event(_this) {
    var gaEventCat = _this.data('category');
    var gaEventAction = _this.data('action');
    var gaEventLabel = _this.data('label');
    gaEventLabel = gaEventLabel && gaEventLabel.length !== 0 ? gaEventLabel : '';
    send_event_raw(gaEventCat, gaEventAction, gaEventLabel);
  }
  function send_event_raw(category, action, label) {
    if (category && action && category.length !== 0 && action.length !== 0) {
      gtag('event', 'document_download', {
        event_category: category,
        event_action: action,
        event_label: label
      });
      console.log('Custom Event Tracked\nAction: ' + action + '\nCategory: ' + category + '\nLabel: ' + label);
    }
  }
})(jQuery);

},{}]},{},[1]);
